import request from '@/utils/request'

//获取调训人员
export function getUserList(params) {
    return request({
        url: '/api/TrainPeople/GetUserList',
        method: 'get',
        params
    })
}

//添加根据部门调训人员
export function addByDept(params) {
    return request({
        url: '/api/TrainPeople/AddByDept',
        method: 'get',
        params
    })
}

//添加调训人员
export function addUserList(data) {
    return request({
        url: '/api/TrainPeople/Add',
        method: 'post',
        data
    })
}

//删除调训人员
export function deleteUserList(data) {
    return request({
        url: '/api/TrainPeople/Delete',
        method: 'post',
        data
    })
}

//修改调训人员
export function updateUserList(data) {
    return request({
        url: '/api/TrainPeople/Update',
        method: 'post',
        data
    })
}

//导入调训人员
export function importPeople(url,data) {
    return request({
        url: url,
        method: 'post',
        data
    })
}

//确认报名
export function passTrainPeople(data) {
    return request({
        url: '/api/TrainPeople/PassTrainPeople',
        method: 'post',
        data
    })
}

//导入调训人员成绩
export function importScore(url,data) {
    return request({
        url: url,
        method: 'post',
        data
    })
}

//修改成绩
export function updateScore(params) {
    return request({
        url: '/api/TrainSubject/UpdateUserScore',
        method: 'get',
        params
    })
}

//获取部门人员
export function getUser(params) {
    return request({
        url: '/api/pmiUser/load',
        method: 'get',
        params
    })
}

//ID获取部门人员
export function getUserById(params) {
    return request({
        url: '/api/PmiUser/Get',
        method: 'get',
        params
    })
}

//我训历
export function getMyTrainOver(params) {
    return request({
        url: '/api/Center/GetMyTrainOver',
        method: 'get',
        params
    })
}

//我训历的考试
export function getMyExamOver(params) {
    return request({
        url: '/api/Center/GetMyExamOver',
        method: 'get',
        params
    })
}

//人员类型
export function GetList(params) {
    return request({
        url: '/api/TrainTask/GetTaskPeople',
        method: 'get',
        params
    })
}
//获取课程信息
export function getListCourse(params) {
    return request({
        url: '/api/TrainCourse/GetList',
        method: 'get',
        params
    })
}
//获取我的培训班学习课程通知
export function getMyCourse(params) {
    return request({
        url: '/api/TrainCourse/GetMyCourse',
        method: 'get',
        params
    })
}












